export const dynamicFormStyles = {
  form: {
    width: '100%',
  },

  title: {
    mb: 3,
    fontWeight: 600,
    color: 'text.primary',
  },

  errorAlert: {
    mb: 3,
    '& ul': {
      margin: 0,
      paddingLeft: 2,
    },
    '& li': {
      fontSize: '0.875rem',
    },
  },

  fieldsContainer: {
    mb: 3,
  },

  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    gap: 2,
    pt: 2,
    borderTop: '1px solid',
    borderColor: 'divider',
  },

  cancelButton: {
    minWidth: '100px',
  },

  submitButton: {
    minWidth: '120px',
  },
};
